import { render, staticRenderFns } from "./RcKakaoSignup.vue?vue&type=template&id=895ae1e8"
import script from "./RcKakaoSignup.vue?vue&type=script&lang=js"
export * from "./RcKakaoSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports